import { IAnalyticRubricCriterion } from '@/components/staffer/ExerciseBuilder/Rubric/useQuestionRubric';
import React from 'react';

type PreviewCriterionCellProps = {
  data: IAnalyticRubricCriterion;
  locale?: Lowercase<Locale>;
};

const PreviewCriterionCell = ({
  data,
  locale = 'en',
}: PreviewCriterionCellProps) => {
  const { name_en: nameEn, name_es: nameEs } = data;
  return (
    <div>
      {locale === 'en' ? nameEn : nameEs}
    </div>
  );
};

export default PreviewCriterionCell;
